import {
  createRootRoute,
  Outlet,
  useNavigate,
  useRouterState
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Toaster } from "@/components/ui/sonner";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle
} from "@/components/ui/empty";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/auth.store";

export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound
});

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex h-full items-center justify-center">
      <Empty>
        <EmptyHeader>
          <EmptyTitle>{t("notFound.title")}</EmptyTitle>
          <EmptyDescription>{t("notFound.description")}</EmptyDescription>
        </EmptyHeader>
        <Button onClick={() => navigate({ to: "/" })}>
          {t("notFound.goHome")}
        </Button>
      </Empty>
    </div>
  );
}

function RootLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const validate = useAuthStore((s) => s.validate);
  const navigate = useNavigate();
  const pathname = useRouterState({
    select: (routerState) => routerState.location.pathname
  });

  useEffect(() => {
    validate();
  }, [validate]);

  useEffect(() => {
    if (!isAuthenticated && isProtectedPath(pathname)) {
      navigate({ to: "/login", replace: true });
    }
  }, [isAuthenticated, navigate, pathname]);

  return (
    <div className="h-dvh overflow-hidden bg-background text-foreground">
      <Outlet />
      <Toaster richColors position="top-right" />
    </div>
  );
}

function isProtectedPath(pathname: string): boolean {
  return (
    pathname === "/chats" ||
    pathname.startsWith("/chats/") ||
    pathname === "/projects" ||
    pathname.startsWith("/projects/") ||
    pathname === "/admin" ||
    pathname.startsWith("/admin/")
  );
}
